export default "__VITE_ASSET__CccB5P3r__"